import * as React from 'react'
import { CollapsibleList } from '@local/do-secundo-collapsible-list'
import { useSessionStorage } from '../../../../client/hooks/use-session-storage'
import { OPEN_MENU_LIST } from './constants'
import { OverviewLink } from './OverviewLink'

export interface IdNameProps {
  id: string
  name: string
}

export interface IdNameGroupsProps extends IdNameProps {
  groups?: IdNameProps[]
}

export const MenuOverview = ({ menus }: { menus: IdNameGroupsProps[] }) => {
  const [openedLists, setOpenedLists] = useSessionStorage(OPEN_MENU_LIST, {})

  if (!menus) {
    return null
  }

  const formattedMenus = menus.length === 1 ? menus[0].groups : menus

  return (
    <div className='mt-10'>
      {formattedMenus?.map((menu: IdNameGroupsProps) =>
        menu.groups ? (
          <CollapsibleList
            header={menu.name}
            defaultCollapsed={!openedLists[menu.id]}
            key={menu.id}
            handleOnClick={() =>
              setOpenedLists({
                ...openedLists,
                [menu.id]: !openedLists[menu.id]
              })
            }
          >
            {menu.groups?.map((group) => (
              <OverviewLink key={group.id} item={group} />
            ))}
          </CollapsibleList>
        ) : (
          <div
            className='font-semibold border-t-0 border-b border-l-0 border-r-0 border-solid border-oo-black-12'
            key={menu.id}
          >
            <OverviewLink item={menu} />
          </div>
        )
      )}
    </div>
  )
}
